import { useLocalStorage } from 'root/src/client/web/hooks/useLocalStorage';
import { useUserCreatorData } from 'root/src/client/logic/auth/hooks/useUser';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { ButtonNew, ButtonNewVariant } from 'root/src/client/v2/common/components/form/ButtonNew';
import { getChannelUrlByPlatform } from 'root/src/shared/creator/helpers/creatorProfile.helpers';
import { PlatformIcon } from 'root/src/client/web/base/CustomButton/PlatformIcon';
import { memo } from 'react';
import Link from 'next/link';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
export const PreferredPlatformReachedMaxDaresModal = memo(({ onClose, onSubmit, platform, }) => {
    const [showPlatformAdjustedModal, setShowPlatformAdjustedModal] = useLocalStorage('showPlatformAdjustedModal', true);
    const { tokens } = useUserCreatorData();
    const targetToken = tokens.find(token => token.platform === platform);
    const preferredToken = tokens.find(token => token.isPreferred);
    return (<ModalLayout className="gap-8">
			<h1 className="text-warning text-2xl uppercase font-mono font-bold">Warning</h1>
			<div className="flex flex-col gap-3">
				<p className="text-center">Your preferred profile{' '}
					<UserDataTokenLink token={preferredToken}/>
					has reached the limit of accepted dares for this Drop.
				</p>
				<p className="text-center">This Dare will be assigned to{' '}
					<UserDataTokenLink token={targetToken}/>.
				</p>
			</div>
			<Link href={routeUrls.connectedChannels()}>
				<a className="underline text-link text-sm">
					You can update your preferred profile here.
				</a>
			</Link>
			<FormControlLabel control={(<Checkbox value={showPlatformAdjustedModal} onChange={(_, checked) => setShowPlatformAdjustedModal(!checked)}/>)} label={<span className="ml-2 select-none">Don't show this message again</span>}/>
			<div className="flex gap-6">
				<ButtonNew variant={ButtonNewVariant.Error} onClick={onClose} type="button">
					Cancel
				</ButtonNew>
				<ButtonNew onClick={onSubmit} type="button">
					Continue
				</ButtonNew>
			</div>
		</ModalLayout>);
});
const UserDataTokenLink = memo(({ token }) => {
    return (<a href={getChannelUrlByPlatform({
            platform: token.platform,
            mnemonicId: token.mnemonicId,
        })} rel="noreferrer" className="font-medium underline whitespace-nowrap">
			<PlatformIcon platform={token.platform} size="1x"/>{' '}
			{token.displayName}{' '}
		</a>);
});
